import React, { useState, useEffect } from "react";
import {
  Spinner,
  Stack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import { Select as ReactSelect } from "chakra-react-select";

import GeneralTab from "./components/GeneralTab";
import FilesTab from "./components/FilesTab";
import FiliesTabLog from "./components/FiliesTabLog";
import PageDetailHeader from "components/PageDetailHeader/PageDetailHeader";

import useDocumentTitle from "hooks/useDocumentTitle";

import GetCurrentUserSuppliers from "services/GetCurrentUserSuppliers";

import SupplierDetailBreadcrumbConstant from "constants/BreadCrumbConstants/SupplierDetailBreadcrumbConstant";

export default function SupplierDetail() {
  const location = useLocation();
  const navigate = useNavigate();

  // Access the passed data
  const supplierData = location?.state?.data;

  const defaultTab = location?.state?.default_tab;

  useDocumentTitle(supplierData?.supplier_name + " Detail");

  const { supplier_id } = useParams();

  const [supplierId, setSupplierId] = useState(supplier_id);

  const [suppliersList, setSuppliersList] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(
    supplierData?.supplier_id
  );
  const [isLoading, setIsLoading] = useState(false);

  const navigateToSupplierDetail = (data, defaultTab) => {
    const link = "/user/suppliers/" + data.supplier_id;

    navigate(link, {
      state: { data: data, default_tab: defaultTab },
    }); // Step 3: Use navigate function
  };

  useEffect(() => {
    const getSuppliers = async () => {
      setIsLoading(true);

      const params = {
        page_number: -1,
      };

      const response_suppliers_data = await GetCurrentUserSuppliers(params);

      const selectValues = response_suppliers_data.data.data.map((item) => {
        return {
          value: item?.supplier?.supplier_id,
          label: item?.supplier?.supplier_name,
          ...item.supplier,
        };
      });

      setSuppliersList(selectValues);

      setIsLoading(false);
    };

    getSuppliers();
  }, []);

  return (
    <div className=" ">
      <Stack spacing={"2rem"}>
        <div className=" flex flex-row ">
          <div className="w-4/5">
            <PageDetailHeader
              breadCrumbList={SupplierDetailBreadcrumbConstant}
              heading={supplierData?.supplier_name}
            />
          </div>
          <div className="w-1/5 my-auto ">
            {isLoading && <Spinner className="my-auto" size="sm" />}

            {!isLoading && (
              <ReactSelect
                options={suppliersList}
                placeholder="Select Supplier"
                isDisabled={isLoading}
                value={suppliersList.find(
                  (item) => item.value === selectedSupplier
                )}
                onChange={(selectedOption) => {
                  setSupplierId(selectedOption.value);
                  setSelectedSupplier(selectedOption.value);
                  navigateToSupplierDetail(selectedOption, 0);
                }}
              />
            )}
          </div>
        </div>
        <div>
          <Tabs defaultIndex={defaultTab}>
            <TabList>
              <Tab>General</Tab>
              <Tab>Files</Tab>
              <Tab>Logs</Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <GeneralTab supplierData={supplierData} />
              </TabPanel>
              <TabPanel>
                <FilesTab supplier_id={supplierId} />
              </TabPanel>
              <TabPanel>
                <FiliesTabLog supplier_id={supplierId} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </div>
      </Stack>
    </div>
  );
}
